import type { FC, PropsWithChildren } from "react";
import { ThemeProvider } from "styled-components";
import { GreenDarkTheme, PurpleDarkTheme } from "@viagogo/core/themes";
import { useIsStubhub } from "src/shared/utils/appContextHelper";

const useDarkTheme = () => {
  const isStubHub = useIsStubhub();

  return isStubHub ? PurpleDarkTheme : GreenDarkTheme;
};

export const ClearHeroThemeProvider: FC<PropsWithChildren> = ({ children }) => {
  const darkTheme = useDarkTheme();
  return <ThemeProvider theme={darkTheme}>{children}</ThemeProvider>;
};
